import { render } from "./BrandSignupHero.vue?vue&type=template&id=64667c12&scoped=true"
import script from "./BrandSignupHero.vue?vue&type=script&lang=js"
export * from "./BrandSignupHero.vue?vue&type=script&lang=js"

import "./BrandSignupHero.vue?vue&type=style&index=0&id=64667c12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64667c12"]])

export default __exports__